import { createAttachmentsApi } from '#/api/platform/attachments';

export const customerOrderAttachmentsApi = createAttachmentsApi(
  (businessId) => `/crm/customer-order/${businessId}/attachments`,
);
